module.exports = __webpack_public_path__ + "media/images/front/about/icon01-e23cd1ae3c08c54951bc6c3d7fa346cb.png";